module.exports = __webpack_public_path__ + "media/images/battery_yellow-91f16f7a1d5a8374d192827a10118f65.png";